import { Box } from "@mui/material";
import { useAlertSourceStatusCharts } from "./alertStatusChart";
import { ResolutionsLineChart } from "./ResolutionsLineChart";

interface AlertsResolutionsMetricsProps {
  startDate: string;
  endDate: string;
  companyId: number | null;
}

export default function AlertsResolutionsMetrics(props: AlertsResolutionsMetricsProps) {
  const { data, loading } = useAlertSourceStatusCharts("resolutions", ["ethoca", "cdrn"], props);
  const ethocaData = data.ethoca ?? null;
  const cdrnData = data.cdrn ?? null;

  const hasAnyData =
    (ethocaData && ethocaData.summary.total > 0) || (cdrnData && cdrnData.summary.total > 0);
  if (!loading && !hasAnyData) {
    return null;
  }

  return (
    <Box sx={{ mt: 3, display: "flex", gap: 3, flexWrap: { xs: "wrap", md: "nowrap" }, alignItems: "flex-start" }}>
      <ResolutionsLineChart title="Ethoca Resolutions (Manual vs Auto)" data={ethocaData} loading={loading} />
      <ResolutionsLineChart title="CDRN Resolutions (Manual vs Auto)" data={cdrnData} loading={loading} />
    </Box>
  );
}
